function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "21",
  viewBox: "0 0 19 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.084 10.771l2.192 2.694 4.722-5.21",
  stroke: "currentColor",
  strokeWidth: ".85",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.64 5.232a.362.362 0 00-.305-.326c-3.003-.474-4.769-1.441-7.877-4.31a.361.361 0 00-.49 0C5.858 3.465 4.093 4.432 1.09 4.906a.362.362 0 00-.304.326c-.242 3.11.39 6.226 1.826 8.996.7 1.37 1.612 2.622 2.701 3.71a11.877 11.877 0 003.76 2.534c.09.037.19.037.279 0a11.875 11.875 0 003.76-2.535 14.668 14.668 0 002.701-3.709 16.735 16.735 0 001.826-8.996z",
  stroke: "currentColor",
  strokeWidth: ".85",
  strokeLinejoin: "round"
})));